// /Data/blogs.js
import BLOG_IMAGE_1 from "../web_core/images/imgi_36_news-4.jpg";
import BLOG_IMAGE_2 from "../web_core/images/imgi_38_news-5.jpg";
import BLOG_IMAGE_3 from "../web_core/images/imgi_40_news-6.jpg";
import BLOG_IMAGE_4 from "../web_core/images/imgi_42_news-7.jpg";
import BLOG_IMAGE_5 from "../web_core/images/imgi_22_course-7.jpg";
import BLOG_IMAGE_6 from "../web_core/images//imgi_36_news-4.jpg";

export const blogs = [
  {
    id: 1,
    title: "5 Tips for Effective Quran Study",
    image: BLOG_IMAGE_1,
    date: "Jan 12, 2026",
    author: "Sheikh Ahmad",
    excerpt: "Learn simple yet effective ways to improve your Quran reading skills in just 15 minutes a day...",
    content: `<p>Tip 1: Set aside a fixed time daily for Quran study...</p>
              <p>Tip 2: Use a Mushaf with Tajweed rules highlighted...</p>
              <p>Tip 3: Recite aloud and listen to a Qari...</p>
              <p>Tip 4: Review previous pages regularly...</p>
              <p>Tip 5: Make dua for understanding and consistency...</p>`,
  },
  {
    id: 2,
    title: "5 Tips for Effective Quran Study - Part 2",
    image: BLOG_IMAGE_2,
    date: "Jan 12, 2026",
    author: "Sheikh Ahmad",
    excerpt: "Learn advanced techniques for memorization and comprehension...",
    content: `<p>Advanced techniques for memorization and comprehension...</p>
              <p>Learn how to revise efficiently and track progress...</p>`,
  },
  {
    id: 3,
    title: "5 Tips for Effective Quran Study - Part 3",
    image: BLOG_IMAGE_3,
    date: "Jan 12, 2026",
    author: "Sheikh Ahmad",
    excerpt: "Tips for group study and correcting common mistakes...",
    content: `<p>Dealing with common mistakes and improving tajweed...</p>
              <p>Tips for group study and online resources...</p>`,
  },
  {
    id: 4,
    title: "5 Tips for Effective Quran Study - Part 4",
    image: BLOG_IMAGE_4,
    date: "Jan 12, 2026",
    author: "Sheikh Ahmad",
    excerpt: "Maintaining consistency and motivation for long-term study...",
    content: `<p>Maintaining consistency and motivation for long-term study...</p>
              <p>Combining reading with reflection for deeper understanding...</p>`,
  },
  {
    id: 5,
    title: "Understanding Tajweed Rules",
    image: BLOG_IMAGE_5,
    date: "Jan 8, 2026",
    author: "Bilal Khan",
    excerpt: "Tajweed helps you recite the Quran properly. This guide covers the most common mistakes...",
    content: `<p>Tajweed ensures proper pronunciation of Quranic letters...</p>
              <p>Common mistakes include mispronouncing letters with similar articulation points...</p>
              <p>Follow the rules of Idgham, Iqlab, and Ikhfa for better recitation...</p>`,
  },
  {
    id: 6,
    title: "Islamic History: Key Events",
    image: BLOG_IMAGE_6,
    date: "Jan 5, 2026",
    author: "Dr. Hamza",
    excerpt: "Explore the rich history of Islam from the Prophet ﷺ to modern times in a concise summary...",
    content: `<p>Islam began in the 7th century in Makkah with the Prophet ﷺ...</p>
              <p>Key events include the Hijrah to Madinah, Battle of Badr, and the compilation of the Quran...</p>
              <p>Modern Islamic history involves the Ottoman Empire, colonial periods, and contemporary movements...</p>`,
  },
];